const loginWindowFeatures = {
};

export default {
  name: 'AWS',
  typeCode: 'AWS',
  loginWindowFeatures,
};
    


// WEBPACK FOOTER //
// ./src/service/coa/csp/aws.js